'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.days;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/days.js
// module id = 663
// module chunks = 0